import { SUPPORTED_LANGUAGES } from '../Constants';

export default function getLanguageSelectOptions() {
    return Object.values(SUPPORTED_LANGUAGES).map((lang) => ({
        value: lang.localeCode,
        label: lang.label
    }));
}
